/**
 * What each module needs in a customer's AUTH tenant: the tenant's claims (`scopes`) and the scopes of the
 * installation's service client `wms` (`clientScopes`: what the WorkServer itself calls with).
 */
export interface Module {
  id: string;
  label: string;
  scopes: string[];
  clientScopes: string[];
}

export const MODULES: Module[] = [
  {
    id: 'stats',
    label: 'Statistics (datacollector)',
    scopes: ['datacollector:write'],
    clientScopes: ['datacollector:write'],
  },
  { id: 'box', label: 'Box calculation', scopes: ['boxcalc:calculate'], clientScopes: ['boxcalc:calculate'] },
  {
    id: 'pq',
    label: 'Print queue',
    scopes: ['printqueue:enqueue', 'printqueue:print'],
    clientScopes: ['printqueue:enqueue'],
  },
  {
    id: 'auto',
    label: 'Automation gateway',
    scopes: ['automation-gw:location:read', 'automation-gw:tunnel'],
    clientScopes: ['automation-gw:location:read'],
  },
  { id: 'buddy', label: 'nyceBuddy', scopes: ['nycebuddy:ask', 'nycebuddy:mcp'], clientScopes: [] },
];

export const DEFAULT_MODULES = ['stats', 'box', 'pq'];

export const modulesOf = (ids: string[]) => MODULES.filter((m) => ids.includes(m.id));
export const tenantScopesFor = (ids: string[]) => [...new Set(modulesOf(ids).flatMap((m) => m.scopes))];
export const clientScopesFor = (ids: string[]) => [...new Set(modulesOf(ids).flatMap((m) => m.clientScopes))];
